<script lang="ts">
  import { subscriptionStore, subscriptionType, trialInfo } from '$lib/stores/subscription'
  import { openPricingModal } from '$lib/stores/subscription'
  import { demoTracker } from '$lib/stores/demoStore'

  // Single Responsibility: Display subscription status
  function getTrialStatusText(): string {
    // Check if demo mode is active
    if (demoTracker.isDemoMode()) {
      return 'DEMO'
    }

    if ($subscriptionType === 'trial' && $trialInfo) {
      return `체험 ${$trialInfo.daysRemaining}일 남음`
    }
    return $subscriptionType ? $subscriptionType.toUpperCase() : 'FREE'
  }
  
  function getTrialStatusColor(): string {
    // Demo mode gets its own color
    if (demoTracker.isDemoMode()) {
      return 'demo'
    }

    if ($subscriptionType === 'trial' && $trialInfo) {
      if ($trialInfo.daysRemaining <= 2) return 'error'
      if ($trialInfo.daysRemaining <= 5) return 'warning'
      return 'success'
    }
    return 'warning'
  }

  function handleUpgradeClick() {
    openPricingModal()
  }

  // Show badge for demo mode or non-premium users
  $: showBadge = demoTracker.isDemoMode() || $subscriptionType !== 'premium'
</script>

{#if showBadge}
  <div class="subscription-badge" data-status={getTrialStatusColor()}>
    <span class="subscription-text">{getTrialStatusText()}</span>
    {#if !demoTracker.isDemoMode() && ($subscriptionType === 'trial' || $subscriptionType === 'free')}
      <button class="upgrade-btn" on:click={handleUpgradeClick}>업그레이드</button>
    {/if}
  </div>
{/if}

<style>
  .subscription-badge {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 3px 8px;
    border-radius: 5px;
    font-size: 10px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.02em;
  }

  .subscription-badge[data-status="success"] {
    background: rgba(16, 185, 129, 0.08);
    color: var(--success);
    border: 1px solid rgba(16, 185, 129, 0.2);
  }

  .subscription-badge[data-status="warning"] {
    background: rgba(245, 158, 11, 0.08);
    color: var(--warning);
    border: 1px solid rgba(245, 158, 11, 0.2);
  }

  .subscription-badge[data-status="error"] {
    background: rgba(239, 68, 68, 0.08);
    color: var(--error);
    border: 1px solid rgba(239, 68, 68, 0.2);
  }

  .subscription-badge[data-status="demo"] {
    background: rgba(147, 51, 234, 0.08);
    color: #9333ea;
    border: 1px solid rgba(147, 51, 234, 0.2);
  }

  .subscription-text {
    white-space: nowrap;
  }

  .upgrade-btn {
    padding: 2px 6px;
    background: var(--accent-primary);
    color: #ffffff;
    border: none;
    border-radius: 3px;
    font-size: 9px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.15s ease;
    opacity: 0.9;
  }

  .upgrade-btn:hover {
    opacity: 1;
    transform: translateY(-0.5px);
  }
  
  /* Dark mode handled by CSS variables */
</style>